/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import Event from "sap/ui/base/Event";

enum UIEvents {
    ESHSearchFinished = "ESHSearchFinished",
    ESHSearchStarted = "ESHSearchStarted",
    ESHSearchLayoutChanged = "ESHSearchLayoutChanged",
    ESHSelectionChanged = "ESHSelectionChanged",
    ESHResultViewTypeChanged = "ESHResultViewTypeChanged",
    ESHShowResultDetail = "ESHShowResultDetail",
    ESHBasketChanged = "ESHBasketChanged",
    ESHPublicModelChanged = "ESHPublicModelChanged", // some public model changes need rerendering updates
}

export default UIEvents;

interface IUiEventParametersBase {
    originalEvent?: Event;
}
export interface IUiEventParametersResultViewTypeChanged extends IUiEventParametersBase {
    newValue: string;
    oldValue: string;
}
export interface IUiEventParametersShowResultDetail extends IUiEventParametersBase {
    resultItemKey: string;
}
export interface IUiEventParametersBasketChanged extends IUiEventParametersBase {
    count: number;
}
export interface IUiEventParametersPublicModelChanged extends IUiEventParametersBase {
    changedPropertyIds: string[];
}
export interface IUiEventParametersResultViewSelectionChanged extends IUiEventParametersBase {
    // ToDo: To be finalized, see HDBFIORISEARCH-2025
    newValue: string;
    oldValue: string;
}
export interface IUiEventParametersSearchFinishedPublic extends IUiEventParametersBase {
    searchTerm: string;
}
